import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/trust-fund-report")({
  beforeLoad: ({ context }) => guardRoute(context.me, "trust-fund-report"),
  component: Outlet,
});
